export const GET_CUSTOM_FORM_DATA_FOR_ALIAS = 'GET_CUSTOM_FORM_DATA_FOR_ALIAS';
export const GET_ZIP_FROM_CUSTOM_FORM = 'GET_ZIP_FROM_CUSTOM_FORM';
export const GET_FAVORITES_IDS_RECURSIVELY = 'GET_FAVORITES_IDS_RECURSIVELY';
export const GET_PAGE_ID_FOR_URL = 'GET_PAGE_ID_FOR_URL';
export const GET_CHANNEL_SLIDES_FOR_QUERY = 'GET_CHANNEL_SLIDES_FOR_QUERY';
export const HAS_PASSES_TO_SHOW = 'HAS_PASSES_TO_SHOW';
export const GET_MERGED_PASSES_BY_NAME = 'GET_MERGED_PASSES_BY_NAME';
export const TRIAL_ACCESS_AVAILABLE = 'TRIAL_ACCESS_AVAILABLE';
export const GET_EVENT_PREROLLS = 'GET_EVENT_PREROLLS';
export const GET_CURRENCY = 'GET_CURRENCY';
export const GET_ATTRIBUTES_FOR_HOMEPAGE = 'GET_ATTRIBUTES_FOR_HOMEPAGE';
export const GROUPED_ATTRIBUTES_BY_ID_MAP_GROUP_ALIAS = 'GROUPED_ATTRIBUTES_BY_ID_MAP_GROUP_ALIAS';
export const ATTRIBUTES_BY_ID = 'ATTRIBUTES_BY_ID';
export const ATTRIBUTES_VALUES_BY_ID = 'ATTRIBUTES_VALUES_BY_ID';
export const ATTRIBUTES_BY_ALIAS_MAP = 'ATTRIBUTES_BY_ALIAS_MAP';
export const ATTRIBUTES_GROUPS_ALISA_TO_ID_MAP = 'ATTRIBUTES_ALISA_TO_ID_MAP';
export const SPORT_MAP_BY_ALIAS = 'SPORT_MAP_BY_ALIAS';
export const GET_USER_DATA = 'GET_USER_DATA';
export const ALL_CLIPS = 'ALL_CLIPS';
export const EVENT_AUTO_CLIPS = 'EVENT_AUTO_CLIPS';
export const IS_LOGGED = 'isLogged';
export const VOD_RAILS = 'VOD_RAILS';
export const CATEGORY_BY_ALIAS_MAP = 'CATEGORY_BY_ALIAS_MAP';
export const CATEGORY_BY_NAME_MAP = 'CATEGORY_BY_NAME_MAP';
export const CATEGORY_BY_ID = 'CATEGORY_BY_ID';
export const DISPLAYABLE_CATEGORIES = 'DISPLAYABLE_CATEGORIES';
export const DISPLAYABLE_CATEGORIES_CROSS_FILTER = 'DISPLAYABLE_CATEGORIES_CROSS_FILTER';
export const CATEGORIES_FOR_HOMEPAGE = 'CATEGORIES_FOR_HOMEPAGE';
export const CATEGORIES_FOR_HOMEPAGE_CROSS_FILTER = 'CATEGORIES_FOR_HOMEPAGE_CROSS_FILTER';
export const PARTICIPANTS_BY_ALIAS_MAP = 'PARTICIPANTS_BY_ALIAS_MAP';
export const PARTICIPANTS_BY_NAME_MAP = 'PARTICIPANTS_BY_NAME_MAP';
export const GROUPS_BY_ALIAS_MAP = 'GROUPS_BY_ALIAS_MAP';
export const GROUPS_BY_NAME_MAP = 'GROUPS_BY_NAME_MAP';
export const GROUPS_FOR_HOMEPAGE = 'GROUPS_FOR_HOMEPAGE';
export const GROUPS_FOR_HOMEPAGE_CROSS_FILTER = 'GROUPS_FOR_HOMEPAGE_CROSS_FILTER';
export const GET_PARTICIPANTS_LIST = 'GET_PARTICIPANTS_LIST';
export const GET_PARTICIPANTS_GROUPS_LIST = 'GET_PARTICIPANTS_GROUPS_LIST';
export const GET_GROUPS_LIST_CROSS_FILTER = 'GET_GROUPS_LIST_CROSS_FILTER';
export const GET_PARTICIPANTS_LIST_CROSS_FILTER = 'GET_PARTICIPANTS_LIST_CROSS_FILTER';
export const PARTICIPANTS_FOR_HOMEPAGE = 'PARTICIPANTS_FOR_HOMEPAGE';
export const PARTICIPANTS_FOR_HOMEPAGE_CROSS_FILTER = 'PARTICIPANTS_FOR_HOMEPAGE_CROSS_FILTER';
export const GET_ACTIVE_PURCHASES = 'GET_ACTIVE_PURCHASES';
export const GET_ACTIVE_PURCHASES_WITH_ADDONS = 'GET_ACTIVE_PURCHASES_WITH_ADDONS';
export const CHECK_IS_PURCHASED = 'CHECK_IS_PURCHASED';
export const SEPARATED_SUBSCRIPTIONS = 'SEPARATED_SUBSCRIPTIONS';
export const GET_ADDONS = 'GET_ADDONS';
export const GET_REGULARS = 'GET_REGULARS';
export const GET_REGULARS_BY_ID = 'GET_REGULARS_BY_ID';
export const GET_ADDONS_BY_ID = 'GET_ADDONS_BY_ID';
export const GET_PREPARED_PACKAGES = 'GET_PREPARED_PACKAGES';
export const GET_PREPARED_PACKAGES_BY_ID = 'GET_PREPARED_PACKAGES_BY_ID';
export const GET_ALL_PURCHASES = 'GET_ALL_PURCHASES';
export const GET_PASSES = 'GET_PASSES';
export const GET_FILTERED_PASSES = 'GET_FILTERED_PASSES';
export const GET_CROSS_FILTER_DATA = 'GET_CROSS_FILTER_DATA';
export const GET_HOME_COMPONENTS = 'GET_HOME_COMPONENTS';
export const GET_PASS_BUILDER = 'GET_PASS_BUILDER';
export const GET_SCHEDULE_FILTERS = 'GET_SCHEDULE_FILTERS';
export const GET_ATTRIBUTES_CROSS_FILTER = 'GET_ATTRIBUTES_CROSS_FILTER';
export const GET_PASSES_FILTERS_TAGS = 'GET_PASSES_FILTERS_TAGS';
export const GET_LOCATIONS_FOR_HOMEPAGE = 'GET_LOCATIONS_FOR_HOMEPAGE';
export const GET_CLIPS_TAGS = 'GET_CLIPS_TAGS';

export const STRIPE = {
  PUBLIC_KEY: 'STRIPE_PUBLIC_KEY',
  TAX_MODE: 'STRIPE_TAX_MODE',
  CONNECTED_ACCOUNT: 'STRIPE_CONTACTED_ACCOUNT',
  API_VERSION: 'STRIPE_API_VERSION',
};
export const USER_SETTINGS = {
  COLLECT_DATA: 'USER_SETTINGS_COLLECT_DATA',
  DISABLE_LOGIN: 'USER_SETTINGS_DISABLE_LOGIN',
  DISABLE_REGISTRATION: 'USER_SETTINGS_DISABLE_REGISTRATION',
};
